<template>
    <div id="pdfContent" class="pdfContent position-relative direction-ltr" :style="{ display: pdfContentDisplay }">
        <div class="pdf-header">
            <div class="d-flex align-items-baseline">
                <div class="col-4 d-flex flex-column">
                    <span>Branch : {{ pdfContent?.branchEnglishName }}</span>
                    <span>date : {{ currentDate("en") }}</span>
                    <span>Tax No. : {{ pdfContent?.taxNo }}</span>
                </div>
                <div class="col-4 d-flex flex-column text-center">
                    <div class="mb-3">
                        <img src="@/assets/logo/SSS/saptco-logo.png" width="180px" alt="logo" />
                    </div>
                    <span>{{ pdfContent?.type }} / عقد نقل ركاب</span>
                    <span>{{ pdfContent?.id }} No / رقم</span>
                    <span>{{ debitClientOrCredit }}</span>
                    <span>{{ pdfContent?.confirmNo }} Confirm No. / رقم التعميد</span>
                </div>

                <div class="col-4 text-end d-flex flex-column">
                    <span>الفرع : {{ pdfContent?.branchArabicName }}</span>
                    <span>التاريخ : {{ currentDate("ar") }}</span>
                    <span>الرقم الضريبي :
                        {{ convertNumbers2Arabic(pdfContent?.taxNo) }}</span>
                </div>
            </div>
        </div>
        <div class="mt-2">
            <div class="d-flex justify-content-between mb-2">
                <h6>Customer Details:</h6>
                <h6 class="text-end">:أولاً : بيانات العميل</h6>
            </div>
            <b-table v-if="customerDetailsItems.length" striped class="text-center table-customer-details m-0"
                thead-class="table-thead table-head__client-statement bg-transparent" tbody-class="table-tbody"
                :fields="customerDetailsFields" :items="customerDetailsItems">
                <template #empty> {{ $t("empty-row") }} </template>
                <template #head(representativeContact)="data">
                    <p v-if="data">أرقام تواصل ممثل العميل</p>
                    <p v-if="data">Representative Contact</p>
                </template>
                <template #head(representative)="data">
                    <p v-if="data">ممثل العميل</p>
                    <p v-if="data">Representative</p>
                </template>
                <template #head(customerContact)="data">
                    <p v-if="data">أرقام تواصل العميل</p>
                    <p v-if="data">Customer Contact</p>
                </template>
                <template #head(address)="data">
                    <p v-if="data">العنوان</p>
                    <p v-if="data">Address</p>
                </template>
                <template #head(customerName)="data">
                    <p v-if="data">اسم العميل</p>
                    <p v-if="data">Customer Name</p>
                </template>
            </b-table>
        </div>
        <hr />
        <div class="mt-1 mb-1">
            <div class="d-flex justify-content-between">
                <h6>Service Description:</h6>
                <h6 class="text-end">:ثانياٌ : وصف الخدمة</h6>
            </div>
            <p class="text-end border p-3 border-secondary border-opacity-25">
                ---
            </p>
        </div>
        <div class="d-flex justify-content-between">
            <h6>Service Details :</h6>
            <h6 class="text-end">:ثالثاٌ : بيانات الخدمة</h6>
        </div>
        <div class="d-flex flex-column" :style="{ minHeight: '630px' }">
            <b-table v-if="servicesDetailsItems.length" striped class="text-center table-services-details m-0 mt-3"
                thead-class="table-thead table-head__client-statement bg-transparent" tbody-class="table-tbody"
                :fields="servicesDetailsFields" :items="servicesDetailsItems.slice(0, 6)">
                <template #empty> {{ $t("empty-row") }} </template>
                <template #head(amount)="data">
                    <p v-if="data">قيمة الخدمة</p>
                    <p v-if="data">Amount</p>
                </template>
                <template #head(vat)="data">
                    <p v-if="data">الضريبة</p>
                    <p v-if="data">Vat%</p>
                </template>
                <template #head(recievingTime)="data">
                    <p v-if="data">وقت الاستلام</p>
                    <p v-if="data">Recieving Time</p>
                </template>
                <template #head(quantity)="data">
                    <p v-if="data">العدد</p>
                    <p v-if="data">Quantity</p>
                </template>
                <template #head(busType)="data">
                    <p v-if="data">نوع الحافلة</p>
                    <p v-if="data">Bus Type</p>
                </template>
                <template #head(destination)="data">
                    <p v-if="data">الوجهة</p>
                    <p v-if="data">Destination</p>
                </template>
                <template #head(recievingArea)="data">
                    <p v-if="data">منطقة الاستلام</p>
                    <p v-if="data">Recieving Area</p>
                </template>
                <template #head(comment)="data">
                    <p v-if="data">ملاحظة</p>
                    <p v-if="data">Comment</p>
                </template>
                <template #head(endDate)="data">
                    <p v-if="data">تاريخ النهاية</p>
                    <p v-if="data">End Date</p>
                </template>
                <template #head(startDate)="data">
                    <p v-if="data">تاريخ البداية</p>
                    <p v-if="data">Start Date</p>
                </template>
                <template #head(description)="data">
                    <p v-if="data">الوصف</p>
                    <p v-if="data">Description</p>
                </template>
                <template #head(s)="data">
                    <p v-if="data">م</p>
                    <p v-if="data">S</p>
                </template>
            </b-table>
            <div class="mt-auto">
                <hr class="mt-3" />
                <div class="d-flex justify-content-between">
                    <p>---</p>
                    <p class="text-end">
                        Page: 1 /
                        {{ Math.ceil((servicesDetailsItems?.length - 6) / 15) + 2 }}
                    </p>
                </div>
            </div>
        </div>
        <div v-if="servicesDetailsItems?.length > 6">
            <div class="d-flex flex-column" :style="{ minHeight: '1020px' }" v-for="index in Math.ceil(
                (servicesDetailsItems?.length - 6) / 15
            )" :key="index">
                <div class="pdf-header">
                    <div class="d-flex align-items-baseline">
                        <div class="col-4 d-flex flex-column">
                            <span>Branch : {{ pdfContent?.branchEnglishName }}</span>
                            <span>date : {{ currentDate("en") }}</span>
                            <span>Tax No. : {{ pdfContent?.taxNo }}</span>
                        </div>
                        <div class="col-4 d-flex flex-column text-center">
                            <div class="mb-2">
                                <img src="@/assets/logo/SSS/saptco-logo.png" width="180px" alt="logo" />
                            </div>
                            <span>{{ pdfContent?.type }} / عقد نقل ركاب</span>
                            <span>{{ pdfContent?.id }} No / رقم</span>
                            <span>{{ debitClientOrCredit }}</span>
                            <span>{{ pdfContent?.confirmNo }} Confirm No. / رقم التعميد</span>
                        </div>

                        <div class="col-4 text-end d-flex flex-column">
                            <span>الفرع : {{ pdfContent?.branchArabicName }}</span>
                            <span>التاريخ : {{ currentDate("ar") }}</span>
                            <span>الرقم الضريبي :
                                {{ convertNumbers2Arabic(pdfContent?.taxNo) }}</span>
                        </div>
                    </div>
                </div>
                <b-table v-if="servicesDetailsItems.length" striped class="text-center table-services-details m-0 mt-3"
                    thead-class="table-thead table-head__client-statement bg-transparent" tbody-class="table-tbody"
                    :fields="servicesDetailsFields" :items="servicesDetailsItems.slice(index * 15 - 9, index * 15 + 6)
                        ">
                    <template #empty> {{ $t("empty-row") }} </template>
                    <template #head(amount)="data">
                        <p v-if="data">قيمة الخدمة</p>
                        <p v-if="data">Amount</p>
                    </template>
                    <template #head(vat)="data">
                        <p v-if="data">الضريبة</p>
                        <p v-if="data">Vat%</p>
                    </template>
                    <template #head(recievingTime)="data">
                        <p v-if="data">وقت الاستلام</p>
                        <p v-if="data">Recieving Time</p>
                    </template>
                    <template #head(quantity)="data">
                        <p v-if="data">العدد</p>
                        <p v-if="data">Quantity</p>
                    </template>
                    <template #head(busType)="data">
                        <p v-if="data">نوع الحافلة</p>
                        <p v-if="data">Bus Type</p>
                    </template>
                    <template #head(destination)="data">
                        <p v-if="data">الوجهة</p>
                        <p v-if="data">Destination</p>
                    </template>
                    <template #head(recievingArea)="data">
                        <p v-if="data">منطقة الاستلام</p>
                        <p v-if="data">Recieving Area</p>
                    </template>
                    <template #head(comment)="data">
                        <p v-if="data">ملاحظة</p>
                        <p v-if="data">Comment</p>
                    </template>
                    <template #head(endDate)="data">
                        <p v-if="data">تاريخ النهاية</p>
                        <p v-if="data">End Date</p>
                    </template>
                    <template #head(startDate)="data">
                        <p v-if="data">تاريخ البداية</p>
                        <p v-if="data">Start Date</p>
                    </template>
                    <template #head(description)="data">
                        <p v-if="data">الوصف</p>
                        <p v-if="data">Description</p>
                    </template>
                    <template #head(s)="data">
                        <p v-if="data">م</p>
                        <p v-if="data">S</p>
                    </template>
                </b-table>
                <div class="mt-auto">
                    <hr class="mt-3" />
                    <div class="d-flex justify-content-between">
                        <p>---</p>
                        <p class="text-end">
                            Page: {{ index + 1 }} /
                            {{
                                Math.ceil((servicesDetailsItems?.length - 6) / 15) + 2
                            }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="pdf-header">
            <div class="d-flex align-items-baseline">
                <div class="col-4 d-flex flex-column">
                    <span>Branch : {{ pdfContent?.branchEnglishName }}</span>
                    <span>date : {{ currentDate("en") }}</span>
                    <span>Tax No. : {{ pdfContent?.taxNo }}</span>
                </div>
                <div class="col-4 d-flex flex-column text-center">
                    <div class="mb-2">
                        <img src="@/assets/logo/SSS/saptco-logo.png" width="180px" alt="logo" />
                    </div>
                    <span>{{ pdfContent?.type }} / عقد نقل ركاب</span>
                    <span>{{ pdfContent?.id }} No / رقم</span>
                    <span>{{ debitClientOrCredit }}</span>
                    <span>{{ pdfContent?.confirmNo }} Confirm No. / رقم التعميد</span>
                </div>

                <div class="col-4 text-end d-flex flex-column">
                    <span>الفرع : {{ pdfContent?.branchArabicName }}</span>
                    <span>التاريخ : {{ currentDate("ar") }}</span>
                    <span>الرقم الضريبي :
                        {{ convertNumbers2Arabic(pdfContent?.taxNo) }}</span>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between text-center mt-3">
            <div class="border py-3 px-2" :class="priceFieldClass">
                <h6>السداد الفوري</h6>
                <hr />
                <h6>شروط الخدمة</h6>
                <div class="text-end">
                    <p class="mb-1">١- يلتزم العميل بالتوقيع على شهادة الخدمة</p>
                    <p class="mb-1">
                        ٢- العميل مسؤول عن هويات وتأشيرات الركاب وتقع عليه اي مخالفات
                        غير نظامية
                    </p>
                    <p class="mb-1">
                        ٣- يلتزم العميل بالزمن المحدد للخدمة وفي حال تجاوز ساعات
                        الخدمة يتم سداد قيمة المدة الزائدة
                    </p>
                    <p class="mb-1">
                        ٤- بلتزم العميل بالمحافظة على الحافلة و حسن استخدامها وعدم وضع
                        اي ملصقات إلا بموافقة الشركة
                    </p>
                    <p class="mb-1">
                        ٥- في حال إلغاء الخدمة من قبل العميل بعد خروج الحافلة /
                        الحافلات لتنفيذ الخدمة تحتسب أجر ساعتين
                    </p>
                </div>
            </div>
            <div class="col-7 text-start ps-3" v-if="showPriceField">
                <div class="row justify-content-between">
                    <p class="col-4 mb-3">Discount %</p>
                    <p class="col-4 mb-3">{{ pdfContent?.discountPercentage }} %</p>
                    <p class="col-4 mb-3 text-end">نسبة الخصم</p>
                </div>
                <hr class="m-0 my-1" />
                <div class="row justify-content-between">
                    <p class="col-4 mb-3">Discount Amount</p>
                    <p class="col-4 mb-3">{{ formattedAmount(pdfContent?.discountAmount) }} SR</p>
                    <p class="col-4 mb-3 text-end">خصومات</p>
                </div>
                <hr class="m-0 my-1" />
                <div class="row justify-content-between">
                    <p class="col-4 mb-3">Discount After</p>
                    <p class="col-4 mb-3">{{ formattedAmount(pdfContent?.discountAfter) }} SR</p>
                    <p class="col-4 mb-3 text-end">القيمة بعد الخصم</p>
                </div>
                <hr class="m-0 my-1" />
                <div class="row justify-content-between">
                    <p class="col-4 mb-3">VAT Rate Value</p>
                    <p class="col-4 mb-3">{{ pdfContent?.vatRateValue }} %</p>
                    <p class="col-4 mb-3 text-end">نسبة الضريبة</p>
                </div>
                <hr class="m-0 my-1" />
                <div class="row justify-content-between">
                    <p class="col-4 mb-3">Value VAT</p>
                    <p class="col-4 mb-3">{{ formattedAmount(pdfContent?.valueVAT) }} SR</p>
                    <p class="col-4 mb-3 text-end">قيمة ضريبة القيمة المضافة</p>
                </div>
                <div>
                    <div class="d-flex justify-content-between align-items-center border mb-2">
                        <p class="me-1 ms-auto mt-3">
                            {{ formattedAmount(pdfContent?.finalPriceIncludingTax) }} SR
                        </p>
                        <p class="custom-p">إجمالي السعر</p>
                    </div>
                    <div class="d-flex justify-content-between align-items-center border" :style="{ height: '58px' }">
                        <p class="me-1 ms-auto mt-3 text-end">
                            {{
                                convertToArabicWords(pdfContent?.finalPriceIncludingTax)
                            }}
                        </p>
                        <p class="custom-p">السعر بالكلمات</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between text-center mt-4">
            <div class="col-5 text-end">
                <h6>
                    تم الإطلاع على بيانات وشروط الخدمة الموضحة اعلاه و أوافق عليها
                </h6>
                <div class="text-end p-3 border mb-3">
                    <p>: توقيع العميل / المندوب</p>
                    <p>: اسم العميل / المندوب</p>
                    <p>: التاريخ</p>
                </div>
                <p>{{ $store.getters['enums/user_info']?.employeeName }} :طبع بواسطة</p>
            </div>
            <div class="col-7 ps-3">
                <h6 class="text-end">مسؤول المبيعات</h6>
                <div class="d-flex border">
                    <div class="col-4 border-end col-4">
                        <p>: التوقيع</p>
                    </div>
                    <div class="col-8">
                        <div class="d-flex justify-content-between align-items-center border">
                            <p class="me-1 ms-auto p-2">{{ pdfContent?.clientName }}</p>
                            <p class="custom-p">: الاسم</p>
                        </div>
                        <div class="d-flex justify-content-between align-items-center border">
                            <p class="me-1 ms-auto p-2">---</p>
                            <p class="custom-p">: الهاتف</p>
                        </div>
                        <div class="d-flex justify-content-between align-items-center border">
                            <p class="me-1 ms-auto p-2">---</p>
                            <p class="custom-p">: هاتف العمل</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center text-center mt-1 flex-column">
            <div class="col-12 d-flex">
                <div class="col-4 d-flex justify-content-between align-items-center border">
                    <p class="me-1 ms-auto p-2 mt-2">553399269</p>
                    <p class="custom-p">عسير</p>
                </div>
                <div class="col-4 d-flex justify-content-between align-items-center border">
                    <p class="me-1 ms-auto p-2 mt-2">3241</p>
                    <p class="custom-p">دمام</p>
                </div>
                <div class="col-4 d-flex justify-content-between align-items-center border">
                    <p class="me-1 ms-auto p-2 mt-2">1603</p>
                    <p class="custom-p">رياض</p>
                </div>
            </div>
            <div class="col-12 d-flex">
                <div class="col-4 d-flex justify-content-between align-items-center border">
                    <p class="me-1 ms-auto p-2 mt-2">4244</p>
                    <p class="custom-p">المدينة المنورة</p>
                </div>
                <div class="col-4 d-flex justify-content-between align-items-center border">
                    <p class="me-1 ms-auto p-2 mt-2">2667</p>
                    <p class="custom-p">مكة</p>
                </div>
                <div class="col-4 d-flex justify-content-between align-items-center border">
                    <p class="me-1 ms-auto p-2 mt-2">2206</p>
                    <p class="custom-p">جدة</p>
                </div>
            </div>
        </div>
        <hr />
        <div>
            <div class="d-flex align-items-center justify-content-between me-2">
                <div class="d-flex">
                    <p class="me-1">Seller :</p>
                    <p>---</p>
                </div>
                <div class="d-flex text-end">
                    <p class="me-1">---</p>
                    <p>: اسم المورد</p>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
                <div class="col-6 d-flex">
                    <p class="me-1 mb-0" :style="{ width: '130px' }">
                        Seller Address :
                    </p>
                    <p class="mb-0" :style="{ height: '54px' }">
                        --- <br />
                        ---
                    </p>
                </div>
                <div class="w-auto d-flex text-end">
                    <p class="me-1 mb-0" :style="{ height: '54px' }">
                        ---<br />
                        --- <br />---
                    </p>
                    <p class="mb-0" :style="{ width: '60px' }">: عنوان المورد</p>
                </div>
            </div>
        </div>
        <hr />
        <div class="d-flex justify-content-between">
            <p class="mb-0">---</p>
            <p class="text-end mb-0">
                Page:
                {{ Math.ceil((servicesDetailsItems?.length - 6) / 15) + 2 }} /
                {{ Math.ceil((servicesDetailsItems?.length - 6) / 15) + 2 }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "OrderDetailsPDF",
    props: ["pdfContent", "pdfContentDisplay", "servicesDetailsItems",
        "customerDetailsItems", "debitClientOrCredit", "customerDetailsFields",
        "servicesDetailsFields", "showPriceField"],
    computed: {
        priceFieldClass() {
            return this.showPriceField ? 'col-5' : 'col-12';
        }
    }
}
</script>

<style lang="scss" scoped>
.pdfContent {
    h6 {
        font-size: 0.8rem;
    }

    p,
    span {
        font-size: 12px !important;
    }

    z-index: -1;

    .custom-p {
        background: var(--color-03) !important;
        color: #fff;
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0;
        align-self: stretch;
    }
}
</style>

<style lang="scss">
.table-customer-details,
.table-services-details {
    th {
        background: var(--color-03) !important;
        color: #fff;

        p {
            margin: 0px !important;
            margin-bottom: 0px !important;
        }
    }
}

.pdfContent .table-customer-details,
.pdfContent .table-services-details {

    th,
    td {
        padding: 0px !important;
        padding-inline: 2px !important;
        padding-block: 3px !important;
        border-bottom: 1px solid #dee2e6;
    }

    td {
        font-size: 9px;
        height: 50px !important;
    }

    thead tr th p {
        font-size: 10px !important;
    }
}
</style>